import { FILE_ATTACH_URL_KEY } from "../../constants/file.constants";
import { getNodeData } from "../../utility/nodeDataHelpers";
import { showMessageBox } from "../UI/messageBox";
import promptBox, { PROMPTBOX_TYPE_OKCANCEL } from "../UI/promptBox";

const urlFromField = (field) => field.value();
const fileNameFromField = (field) => getNodeData(field.getNode(), FILE_ATTACH_URL_KEY);

// if the attachment has been saved to SharePoint, removes from SharePoint first, then removes the attachment node
// if not, just removes the attachment node
async function removeFileAsync(shpAccess, field) {
    const url = urlFromField(field);

    // url will be blank if the file hasn't yet been saved out.
    if (url) {
        await shpAccess.deleteFileAsync(url);
    }

    field.deleteSelf();
}

// String -> Promise[Boolean]
const confirmDelete = async (field) => {
    const fileName = fileNameFromField(field);

    const prompt = promptBox({
        title: "Confirm Removal",
        text:
            `Are you sure you want to delete ${fileName}?\n\nIt will be deleted immediately if you click OK.`,
        type: PROMPTBOX_TYPE_OKCANCEL,
    });

    return await prompt.showAsync();
};

// (DataSourceNode, SharePointAccess) -> Promise[void]
const handleSharePointFileDeleteClickAsync = async (shpAccess, field) => {
    try {
        const shouldDelete = await confirmDelete(field);

        if (shouldDelete) {
            await removeFileAsync(shpAccess, field);
        }
    } catch (e) {
        await showMessageBox(
            'Error',
            `Encountered an error while deleting the file:\n\n${e.message}`,
        );
    }
}

export default handleSharePointFileDeleteClickAsync;
